import React from 'react';
import { API } from '../config';

const ShowPrimaryPhoto = ({product}) => (
    <div className='product-img'>
        <img src={`${API}/static/product_photos/${product.primary_photo}`}alt={product.name} className='mb-2'
            height= {'150px'}
            width ={'auto'}
        />
    </div>
);

export default ShowPrimaryPhoto;
